<template lang="pug">
  .relative.width-100(v-on-clickaway='closeDropdown')
    .input-container.row.middle(:class='{ error, filled: filled && phoneValue && countryCode }')
      button.country-button.row.middle.center(type='button' @click='toggleDropdown')
        img.flag(v-if='selectedCountry.flagIcon' :src='selectedCountry.flagIcon' :width='"18px"' :height='"18px"')
        span.no-flag(v-else)
          | -
        simple-svg(
          :filepath='arrowDown'
          :width='"10px"'
          :height='"10px"'
          :class='{ rotate: isDropdownOpen }'
        )
      .country-code-container.m4-right-2.row.center.middle
        input.country-code-input(
          type='text'
          name='telephone-code'
          @blur='codeValueChange'
          :value='countryCode'
          :disabled='!!selectedCountry.code'
          placeholder='+134'
          ref='codeInput'
        )
      input.item-1.telephone-input(
        type='text'
        name='telephone'
        @input='inputValueChange'
        :value='phoneValue'
        @keypress='preventIfNotNumber'
        :placeholder='placeholder || selectedCountry.example'
        :maxlength='selectedCountry.maxLength || maxTelephoneLength'
      )
    .dropdown-container.absolute.width-100.column.start.kimple-scroll(v-if='isDropdownOpen')
      button.row.middle.option-container.width-100(
        v-for='country in countriesTelephoneFormat'
        :key='country.id'
        @click='selectCountry(country)'
        type='button'
      )
        img.flag-image.m-right-1(:src='country.flagIcon' :alt='country.name')
        span.text-normal
          | {{ `${$t(`countries.${country.name}`)} ${country.code ? `(${country.code})` : ''}` }}
    .row.middle.span-error-txt.m4-top-1(v-show='showError')
      simple-svg.icon.red-icon.m4-right-1(:filepath='stopIcon' :width='"15px"' :height='"15px"')
      span.text-small.red
        | {{ $t('errors.phoneNumberRequiredError') }}
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway'

import arrowDown from '@/assets/ic_chevron-down.svg'
import stopIcon from '@/assets/ic_stop.svg'

import {
  countriesTelephoneFormat,
  countryCodeSeparator,
  firstElement,
  secondElement,
  maxTelephoneLength,
  otherCodeCountry
} from '../../utils/constants'
import { isLetterCharCode } from '../../utils/string'

export default {
  mixins: [ clickaway ],
  data () {
    return {
      arrowDown,
      maxTelephoneLength,
      isDropdownOpen: false,
      countriesTelephoneFormat,
      selectedCountryCode: '',
      stopIcon
    }
  },
  computed: {
    phoneValue() {
      const phoneSplit = this.value.split(countryCodeSeparator)
      return phoneSplit.length > 1 ? phoneSplit[secondElement] : phoneSplit[firstElement]
    },
    selectedCountry() {
      const phoneSplit = this.value.split(countryCodeSeparator)
      const countryByCode = countriesTelephoneFormat.find(country => country.code === phoneSplit[firstElement]) || otherCodeCountry
      return phoneSplit.length > 1 && countryByCode
        ? countryByCode
        : otherCodeCountry
    },
    countryCode() {
      const phoneSplit = this.value.split(countryCodeSeparator)
      return this.selectedCountryCode || phoneSplit[firstElement] || this.selectedCountry.code
    }
  },
  methods: {
    preventIfNotNumber(evt) {
      if (isLetterCharCode(evt.which)) evt.preventDefault()
    },
    inputValueChange(evt) {
      const value = this.countryCode + countryCodeSeparator + evt.target.value
      this.closeDropdown()
      this.$emit('change', value, this.name)
    },
    selectCountry(country) {
      this.isDropdownOpen = false
      const value = country.code + countryCodeSeparator + this.phoneValue
      if (!country.code) {
        this.$nextTick(() => this.$refs.codeInput.focus())
        this.selectedCountryCode = '+'
      } else {
        this.selectedCountryCode = ''
      }
      this.$emit('change', value, this.name)
    },
    closeDropdown() {
      this.isDropdownOpen = false
    },
    toggleDropdown() {
      this.isDropdownOpen = !this.isDropdownOpen
    },
    codeValueChange(evt) {
      this.selectedCountryCode = evt.target.value
      const value = this.countryCode + countryCodeSeparator + this.phoneValue
      this.closeDropdown()
      this.$emit('change', value, this.name)
    }
  },
  props: {
    value: { type: String, required: false, default: '' },
    name: { type: String },
    placeholder: { type: String, required: false },
    required: { type: Boolean, required: false },
    showError: { type: Boolean, required: false },
    error: { type: Boolean, required: false },
    filled: { type: Boolean, required: false }
  }
}
</script>

<style lang="scss" scoped>
@import 'src/scss/variables/colors';

.input-container {
  background-color: $white;
  border: 1px solid $gray;
  border-radius: 6px;
  height: 40px;
  padding-right: 10px;
  &.error{
    border: 1px solid $red;
  }
}

.telephone-input {
  background: transparent;
}

.dropdown-container {
  background-color: $white;
  border: 1px solid $light-gray;
  border-radius: 3px;
  box-shadow: 0 2px 8px 0 $shadow-gray;
  margin-top: 4px;
  max-height: 180px;
  overflow-y: auto;
  z-index: 1;
}

.option-container {
  min-height: 40px;
  padding: 0 16px;
  &:hover {
    background-color: $light-gray;
  }
}

.country-button {
  padding: 0 4px 0 12px;
}

.flag {
  margin-right: 4px;
  min-width: 18px;
}

.rotate {
  transform: rotate(180deg);
}

.country-code-container {
  border-right: 1px solid $gray;
  border-left: 1px solid $gray;
  height: 100%;
  min-width: 50px;
}

.country-code-input {
  background: transparent;
  height: 100%;
  padding: 8px;
  text-align: center;
  width: 50px;

  &:disabled {
    background-color: $light-gray;
  }
}

.no-flag {
  text-align: center;
  width: 22px;
}

.flag-image {
  width: 20px;
}

.filled{
  background-color: $lighter-blue;
}
</style>
